import { ToastConstants } from './toast.constants'
import { IToastAction, IToastState } from './toast.types'

export const initialToastState: IToastState = {
  message: '',
  duration: 2000,
  position: 'top',
  showToast: false,
  color: undefined,
  onDidDismiss: null,
  onWillPresent: null,
  dataTestId: null,
}

export function toastReducer(state: IToastState = initialToastState, action: IToastAction): IToastState {
  switch (action.type) {
    case ToastConstants.SHOW_TOAST:
      return { ...initialToastState, ...action.toast, showToast: true }
    case ToastConstants.HIDE_TOAST:
      return { ...state, showToast: false }
    case ToastConstants.RESET_TOAST:
      return { ...initialToastState }
    default:
      return state
  }
}
